module.exports = __webpack_public_path__ + "media/images/flags/16/GoSquared-34f3ae180b83c5e607b4eec312d4cc71.png";